/**
 * !!!! Read me by NimNim !!!!
 * ทำขึ้นเพื่อจัดการ route path ไม่ให้มองเห็น id หรือ key ต่างๆ ที่ต้องการส่งข้ามหน้ากัน
 * เช่นของเดิม route path เป็น /FormG01?Ref=1 เพื่อไม่ให้เห็น Ref ที่ส่งมา และป้องกันการแก้ไข id
 * จาก url เลยใช้ vuex store เข้ามาช่วยจัดการ state
 * state — คือ object ที่ใช้เก็บข้อมูลที่เราต้องการ
 * mutations — คือ ตัวที่จะคอยไปแก้ไขข้อมูล state
 * actions — คือ ฟังก์ชันที่จะทำการ calculate หรือทำ logic ต่างๆ เพื่อจะได้ผลลัพท์ที่ต้องการ จากนั้นก็จะบอกให้ mutations ไปแก้ไขข้อมูลที่ state
 */
import { StateMarketplaceMutions } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { useRouter } from "vue-router";

export interface Params {
  // ref : แล้วแต่จะใช้ ส่วนมากจะใช้เก็บ id ที่แก้ไข
  sellerProductId: number;
  sellerOrderId: number;
  sellerStoreId: number;
}

export interface ParamsInfo {
  params: Params;
}

@Module
export default class StateMarketplaceModule
  extends VuexModule
  implements ParamsInfo
{
  params = {} as Params;

  //#region seller product Id

  get getCurrentStateSellerProductId(): number {
    const router = useRouter();
    if (!this.params.sellerProductId && this.params.sellerProductId != 0) {
      router.push({
        path: "/Seller/ProductList",
      });
    }
    return this.params.sellerProductId;
  }

  @Mutation
  [StateMarketplaceMutions.SET_SELLER_PRODUCT_ID](id) {
    this.params.sellerProductId = id;
  }

  //#endregion

  //#region Seller order Id
  get getCurrentStateSellerOrderId(): number {
    const router = useRouter();
    if (!this.params.sellerOrderId && this.params.sellerOrderId != 0) {
      router.push({
        path: "/Seller/OrderList",
      });
    }
    return this.params.sellerOrderId;
  }

  @Mutation
  [StateMarketplaceMutions.SET_SELLER_ORDER_ID](id) {
    this.params.sellerOrderId = id;
  }
  //#endregion

  //#region Seller Store Id
  get getCurrentStateSellerStoreId(): number {
    const router = useRouter();
    if (!this.params.sellerStoreId && this.params.sellerStoreId != 0) {
      router.push({
        path: "/Seller/StoreList",
      });
    }
    return this.params.sellerStoreId;
  }
  @Mutation
  [StateMarketplaceMutions.SET_SELLER_STORE_ID](id) {
    this.params.sellerStoreId = id;
  }

  //#endregion
}
